<template>
  <div>
    <template>
      <router-link
        :to="{
          name: 'bpmn',
          params: {
            processId: value.id
          },
        }"
      >
<!--        <font-awesome-icon icon="edit" />-->
        <span>EDIT</span>
      </router-link>
    </template>
  </div>
</template>

<script>

  export default {
    name: "QProcessEditor",

    props: {
      value: {}
    },
    data() {
      return {

      };
    },
    computed: {},
    watch: {

    },
    mounted() {
    },
    methods: {

    },
  };

</script>

<style scoped>


</style>
